import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage/session'

export type RedirectState = {
  redirectUrl: string | null
}

const initialState: RedirectState = {
  redirectUrl: null,
}

const persistConfig = {
  key: 'redirect',
  storage,
}

const slice = createSlice({
  name: 'redirect',
  initialState,
  reducers: {
    setRedirectUrl: (state, { payload }: PayloadAction<string>) => {
      state.redirectUrl = payload
    },
    clearRedirectUrl: (state) => {
      state.redirectUrl = null
    },
  },
})

export const { setRedirectUrl, clearRedirectUrl } = slice.actions

export const redirectReducer = persistReducer(persistConfig, slice.reducer)
